import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './FormDropdown.scss';

const arrowRenderer = () => <div className="form-dropdown-caret" />;

const FormDropdown = props =>
  <div className="form-dropdown">
    <label htmlFor={props.name}>{props.label}</label>
    <Select
      name={props.name}
      className={props.className}
      options={props.items}
      clearable={false}
      searchable={false}
      simpleValue
      placeholder={props.placeholder}
      arrowRenderer={arrowRenderer}
      {...props.input}
    />
    {
      props.meta && props.meta.touched && props.meta.error &&
      <span className="form-validation-message">{props.meta.error}</span>
    }
  </div>
;

FormDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormDropdown/FormDropdown.js
 **/